import right from "./right.svg";
import left from "./left.svg";
import add from "./add.svg";
import enter from "./enter.svg";
const images = { right, left, add, enter };
export default images;
